import { ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { WorkbookAccelerationContentType } from '../ContentTypes';
import { getNoDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { WorkbookAccelerations } from '../../resources/WorkbookAccelerations';

export const WorkbookAccelerationDefinition: ExplorableItemDefinition = {
  itemType: 'workbookAcceleration',
  pluralName: Messages.workbookAccelerations,
  emptyStateMessage: Messages.workbookAccelerationsEmptyMessage,
  contentFilterKeys: WorkbookAccelerationContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return WorkbookAccelerations.all().withExtraParams(WorkbookAccelerationContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
